import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import MessageOutlinedSvg from "@ant-design/icons-svg/es/asn/MessageOutlined";
import AntdIcon from "../components/AntdIcon";
var MessageOutlined = function MessageOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MessageOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  MessageOutlined.displayName = 'MessageOutlined';
}
export default /*#__PURE__*/React.forwardRef(MessageOutlined);